import React from 'react';
import "./DashboardFooter.css";
const DashboardFooter = ({ pendingTasks, setIsSupportOpen, setIsPrivacyOpen }) => {
  return (
    <footer className="dashboard-footer-premium">
      <div className="footer-glass-wrap">
        <div className="footer-section">
          <div className="live-dot-pulse"></div>
          <span className="footer-stat">System Active</span>
          <span className="footer-divider">|</span>
          <span className="footer-stat-detail">{pendingTasks.length} Tasks Pending</span>
        </div>
        <div className="footer-section center-brand">
          <span className="brand-text-footer">AI-BASED <span className="blue-glow">Cortex</span></span>
        </div>
        <div className="footer-section right-links">
          <button className="footer-action-link" onClick={() => setIsSupportOpen(true)}>Support</button>
          <button className="footer-action-link" onClick={() => setIsPrivacyOpen(true)}>Privacy</button>
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;